function setCustomDomain(target, domain, fromScale = false) {
  //scale.x에 대한 customDomain 처리
  let scale = fromScale ? target : this.__execs__.scale[target];
  let field = fromScale ? null : this.__execs__.field[target];
  scale._defaultDomain = domain;
  if (fromScale) {
    scale.domain(domain).nice();
  } else if (this.customDomain()) { // 직접 입력한 경우
    scale.domain(this.customDomain());
  } else if ((this.isMixed ? !this.isMixed() : true) && field.customDomain) { // measure에 추가한 경우 
    scale.domain(field.customDomain);
  } else {
    scale.domain(domain).nice();
  }
  return this;
}

export default setCustomDomain;


// WEBPACK FOOTER //
// ./layouts/default/setCustomDomain.js